import { Box, Typography } from '@dtx-company/design-system/src'
import { DashboardSlug } from '../../../types/reports.types'
import { DashboardTitle } from '../../../constants/reports'
import { FC, useEffect, useState } from 'react'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { reverseEnumLookup } from '@dtx-company/true-common/src/utils/types/reverseEnumLookup'
import { useRouter } from 'next/router'

export const ReturnToReports: FC = () => {
  const [reportTitle, setReportTitle] = useState<string | undefined>()
  const router = useRouter()
  const reportSlug = reverseEnumLookup(DashboardSlug, router.query.dashboard_slug)

  useEffect(() => {
    if (reportSlug) {
      setReportTitle(DashboardTitle[DashboardSlug[reportSlug]])
    }
  }, [reportSlug])

  return (
    <Box
      sx={{
        marginY: 4,
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        cursor: 'default'
      }}
    >
      <Spacer mr={4} />
      <Typography variant="headlineSmall">{reportTitle}</Typography>
    </Box>
  )
}
